import { BASE } from './spacings';
import { LINE_HEIGHT, NAMES } from './typography';

/**
 * These tokens are workarounds that should be corrected on redesign.
 * They are here so that we can trace them and update and remove in future.
 *
 * Everything here should be marked deprecated to warn against ongoing use.
 */

/**
 * Tiny spacer for margin adjustments to line up things with differing
 * line-heights.
 *
 * @deprecated
 */
export const tinySpacer = `${BASE / 4}px` as const;

const NO_WRAP_HEIGHT = BASE * 6;

/**
 * Height of containers with nowrap content, e.g. Banner and Toast.
 *
 * @deprecated
 */
export const noWrapHeight = `${NO_WRAP_HEIGHT}px` as const; // 48px

const BODY_LINE_HEIGHT = LINE_HEIGHT[NAMES.indexOf('body2')]; // 20px

/**
 * Spacer for vertical padding of containers with nowrap content.
 *
 * @see noWrapHeight
 * @deprecated
 */
export const noWrapSpacer = `${
  (NO_WRAP_HEIGHT - BODY_LINE_HEIGHT) / 2
}px` as const;

export const TABLE_TH_TOP_BOTTOM_PADDING = '14px';
